module.exports = __webpack_public_path__ + "img/0Q3B3793_L_Black_MockedUp.0fe4c5da.jpg";